module.exports = __webpack_public_path__ + "fb6bfd2fbc9921685a0d6fe0a97d7995.webp";